/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Who sent us the lead, as distinct from Channel, which records how it reached us. A lead can arrive over WhatsApp from a broker - the two are recorded separately.
 */
export type ReferralSourceType = typeof ReferralSourceType[keyof typeof ReferralSourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReferralSourceType = {
  BROKER: 'BROKER',
  EXISTING_CLIENT: 'EXISTING_CLIENT',
  STAFF: 'STAFF',
  WALK_IN: 'WALK_IN',
  ONLINE: 'ONLINE',
  EVENT: 'EVENT',
  OTHER: 'OTHER',
} as const;
